import Axios from "axios";
import QueryOptions from "../sal-ui/QueryOptions";
import PagedResult from "./PagedResult";
import SbomProjectGroup from "../domain/SbomProjectGroup";

class SbomProjectGroupService {

    readonly basePath = "/sbom-project-groups";

    public add(group: SbomProjectGroup): Promise<string> {
        return Axios.post(`${this.basePath}`, group).then(value => value.data.id);
    }

    public update(groupId: string, group: SbomProjectGroup): Promise<void> {
        return Axios.put(`${this.basePath}/${groupId}`, group);
    }

    public get(id: string): Promise<SbomProjectGroup> {
        return Axios.get(`${this.basePath}/${id}`)
            .then(value => SbomProjectGroup.fromPOJO(value.data));
    }

    public delete(group: SbomProjectGroup): Promise<void> {
        return Axios.delete(`${this.basePath}/${group.id}`);
    }

    public getList(queryOptions: QueryOptions): Promise<PagedResult<SbomProjectGroup>> {
        return Axios.get(`${this.basePath}?${queryOptions.toQueryParams()}`)
            .then(value => {
                const groups = value.data.data
                    .map((objectJson: object) => SbomProjectGroup.fromPOJO(objectJson))
                    .filter((group): group is SbomProjectGroup => group !== null);

                return new PagedResult(value.data.total, groups);
            });
    }

}

export default SbomProjectGroupService;
